// Stand-in for `@sentry/react` and `@sentry/browser` in a build without a
// SENTRY_DSN (webpack.common.js swaps it in). Sentry never initialises in such a
// build, yet its ~500KB of source was still shipped in both HyperLoader.js and
// app.js — about 80KB gzipped the buyer downloaded before the card form.
//
// Only the bindings in Sentry.res are provided. `ErrorBoundary` is not a no-op:
// ErrorBoundary.res renders the SDK's crash fallback through it, so it must still
// catch render errors and hand the fallback the argument shape Sentry uses.
import React from "react";

const noop = () => {};

export const init = noop;
export const captureException = noop;
export const browserTracingIntegration = () => ({});
export const reactRouterV6BrowserTracingIntegration = () => ({});
export const makeFetchTransport = noop;
export const defaultStackParser = noop;
export const getCurrentScope = () => ({ setClient: noop });

export class BrowserClient {
  init() {}
}

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, componentStack: null };
    this.resetError = () =>
      this.setState({ hasError: false, error: null, componentStack: null });
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(_error, errorInfo) {
    this.setState({ componentStack: errorInfo && errorInfo.componentStack });
  }

  render() {
    const { hasError, error, componentStack } = this.state;
    if (!hasError) return this.props.children;
    const { fallback } = this.props;
    return typeof fallback === "function"
      ? fallback({ error, componentStack, resetError: this.resetError })
      : fallback || null;
  }
}
